import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import logger from './logger';
import config from 'config';
var debug = logger.extend('sendToRaygun');
var raygunClient;
export default function sendToRaygun(error) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!config.has('public.raygun.apiKey')) {
    return;
  }

  options = _objectSpread(_objectSpread({}, options), {}, {
    customData: _objectSpread(_objectSpread({}, error.customData), options.customData)
  });

  if (!process.browser) {
    var raygun = require('raygun');

    if (!raygunClient) {
      debug('Creating Raygun client.');
      var apiKey = config.get('public.raygun.apiKey');
      raygunClient = new raygun.Client().init({
        apiKey: apiKey
      });
    }

    debug('Error sent to Raygun: %s', error);
    raygunClient.send(error, options.customData);
  } else {
    if (global.rg4js) {
      debug('Error sent to Raygun: %s', error);
      global.rg4js('send', _objectSpread({
        error: error
      }, options));
    } else {
      debug('Raygun was not found, error will not be sent: %s', error);
    }
  }
}